import type { LastVisitedStock } from "../../interfaces/MarketToday.interface";
import type { RecentlyViewedStockItem } from "./recentlyViewedTypes";

export const mapLastVisitedToStocks = (
  lastVisited: LastVisitedStock[],
): RecentlyViewedStockItem[] =>
  lastVisited.map((stock) => ({
    symbol: stock.symbol,
    fullName: stock.fullName,
    ltp: stock.ltp,
    changePrice: stock.changePrice,
    perChange: stock.perChange,
    redirectURL: stock.redirectURL,
    stockStatus: stock.stockStatus as RecentlyViewedStockItem["stockStatus"],
    exchange: stock.exchange,
    token: stock.token,
  }));
